module.exports = __webpack_public_path__ + "img/meet_us_london_2022.a47383f2.png";